export const menu = [
  {
    title: "Menu",
    sublinks: [
      {
        title: "Dashboard",
        path: "dashboard",
        icon: "dashboard",
      },
      {
        title: "Société",
        path: "societe",
        icon: "apartment",
      },
      {
        title: "Versement de dividendes",
        path: "versements",
        icon: "euro",
      },
    ],
  },
  {
    title: "Application",
    sublinks: [
      {
        title: "Mouvements",
        path: "mouvements",
        icon: "sync_alt",
      },
      {
        title: "Actionnaires",
        path: "actionnaires",
        icon: "group",
      },
      {
        title: "Comptes administrés",
        path: "administres",
        icon: "shield",
      },
      {
        title: "Guichets",
        path: "banques",
        icon: "account_balance",
      },
    ],
  },
  {
    title: "Divers",
    sublinks: [
      {
        title: "Civilités",
        path: "civilites",
        icon: "male",
      },
      {
        title: "Groupes",
        path: "groupes",
        icon: "groups",
      },
      {
        title: "Pays",
        path: "pays",
        icon: "public",
      },
      {
        title: "Enseignes bancaires",
        path: "types-banque",
        icon: "assured_workload",
      },
    ],
  },
  {
    title: "Documents",
    sublinks: [
      {
        title: "Modèles",
        path: "modeles",
        icon: "description",
      },
      {
        title: "Editions / Listings",
        path: "extractions",
        icon: "table_chart",
      },
      // {
      //   title: "Envoi de mails",
      //   path: "mails",
      //   icon: "email",
      // },
    ],
  },
];
